<template>
<div class="kt-list-timeline">
    <slot></slot>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>